module.exports = __webpack_public_path__ + "static/media/sketch_1.f035c749.jpg";